import { NgModule }       from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

import { BetaWarningModule }      from './beta-warning/beta-warning.module';
import { ConfirmModule }          from './confirm/confirm.module';
import { CriticalMessagesModule } from './critical-messages/critical-messages.module';
import { CustomerMessagesModule } from './customer-messages/customer-messages.module';
import { MessagesComponent }      from './messages.component';
import { MessagesService }        from '../messages/messages.service';
import { MessengerModule }        from './messenger/messenger.module';
import { NotificationsModule }    from './notifications/notifications.module';
import { SharedModule }           from '../shared/shared.module';

@NgModule({
  declarations: [
    MessagesComponent
  ],
  entryComponents: [
    MessagesComponent
  ],
  exports: [
    BetaWarningModule,
    ConfirmModule,
    CriticalMessagesModule,
    CustomerMessagesModule,
    MessagesComponent,
    MessengerModule,
    NotificationsModule
  ],
  imports: [
    // Third Party
    NgbToastModule,

    // Custom
    BetaWarningModule,
    ConfirmModule,
    CriticalMessagesModule,
    CustomerMessagesModule,
    MessengerModule,
    NotificationsModule,
    SharedModule
  ],
  providers: [
    MessagesService
  ]
})
export class MessagesModule {}
